import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomersCrmStatisticsAPI from '../../../api/CustomersCrmStatisticsAPI';

type Props = { timeRange: { start: string; end: string } };

function CustomerConversionRateCard({ timeRange }: Props) {
  const { t } = useTranslation();
  const [rate, setRate] = useState<number | null>(null);
  const [uniqueCustomers, setUniqueCustomers] = useState(0);
  const [customersWithSale, setCustomersWithSale] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await CustomersCrmStatisticsAPI.getCustomerConversionRate({
          startTime: timeRange.start,
          endTime: timeRange.end,
        });
        const data = res.data;
        if (data) {
          setUniqueCustomers(data.uniqueCustomers);
          setCustomersWithSale(data.uniqueCustomersWithSale);
          setRate(data.conversionRatePercent);
        } else {
          setRate(0);
          setUniqueCustomers(0);
          setCustomersWithSale(0);
        }
      } catch {
        setRate(0);
        setUniqueCustomers(0);
        setCustomersWithSale(0);
      }
    };
    fetchData();
  }, [timeRange.start, timeRange.end]);

  const displayRate = rate !== null ? `${Number(rate).toFixed(1)}%` : '—';

  return (
    <div className="space-y-1">
      <p className="text-2xl font-bold text-foreground">{displayRate}</p>
      <p className="text-sm text-muted-foreground">
        {t('stats.customer_conversion_rate') || 'Customer conversion rate'}
      </p>
      {(uniqueCustomers > 0 || customersWithSale > 0) && (
        <p className="text-xs text-muted-foreground">
          {t('stats.customer_conversion_rate.breakdown', { withSale: customersWithSale, uniqueCustomers })}
        </p>
      )}
    </div>
  );
}

export default CustomerConversionRateCard;
